import { IZone, IFacility } from '../custom/classes/production';
import { IPackageListingAppState } from '../redux-state';
import { flatMap } from 'lodash';
import { filterMap, filterMapByValue } from './map-helpers';
import { AlternateCartItemType, ISfoCartItem } from '../classes/package-listing';

export interface ICartItemDetail {
    facility: IFacility;
    itemTitle: string;
    itemSeason: string;
    itemDate: string;
    itemTime: string;
    itemIdToRemove: number;
}

export function getCartItemDetails(state: IPackageListingAppState, itemId: number): ICartItemDetail {
    let itemDetail: ICartItemDetail = null;

    if (itemId === 0) {
        return null;
    }

    if (state.packageListingSettings.isFixed) {
        const matchedFixed = state.packageListing.packages.filter(p => p.id == itemId);

        if (matchedFixed.length === 1) {
            itemDetail = {
                facility: matchedFixed[0].facility,
                itemDate: "",
                itemTime: "",
                itemTitle: matchedFixed[0].title,
                itemSeason: matchedFixed[0].season.description,
                itemIdToRemove: itemId
            };
        } else {
            const allSubPackages = flatMap(state.packageListing.packages
                .map(pkg => pkg.subPackages));

            const matchedSubPackage = allSubPackages.filter(p => p.id == itemId)[0];

            if (matchedSubPackage) {
                var packageId = filterMapByValue(state.packageListing.subPackagesInCart,
                    value => {
                        return value.indexOf(matchedSubPackage.id) >= 0
                    }).keys().next().value;

                if (packageId) {
                    const subPackages = state.packageListing.subPackagesInCart.get(packageId);
                    itemDetail = {
                        facility: matchedSubPackage.facility,
                        itemDate: "",
                        itemTime: "",
                        itemIdToRemove: packageId,
                        itemTitle: subPackages.indexOf(matchedSubPackage.id) === 0 ?
                            state.packageListing.packages.filter(p => p.id === packageId)[0].title
                            : "",
                        itemSeason: subPackages.indexOf(matchedSubPackage.id) === 0 ?
                            state.packageListing.packages.filter(p => p.id === packageId)[0].season.description
                            : ""
                    };
                }

            }

        }
    } else {
        const allPerf = flatMap(state.packageListing.packageDetail.performanceGroupDetails
            .map(group => flatMap(group.appProductions.map(prod => prod.performances))));

        const matchedPerf = allPerf.filter(p => p.performanceId == itemId)[0];

        if (matchedPerf) {
            itemDetail = {
                facility: matchedPerf.facility,
                itemDate: matchedPerf.performanceDateDayString,
                itemTime: matchedPerf.performanceTimeString,
                itemTitle: matchedPerf.title,
                itemSeason: "",
                itemIdToRemove: itemId
            };

        }
    }

    return itemDetail;
}

// Helper function to determine if an unseated fixed package cart item has a fully selected alternate line item
export function isFixedUnseatedAlternateItemSelected(item: ISfoCartItem): boolean {
    return item.selectedAlternateItem
        && ((item.selectedAlternateItem.type === AlternateCartItemType.ZONE
            && item.selectedAlternateItem.selectedZoneId > 0)
        || (item.selectedAlternateItem.type === AlternateCartItemType.PACKAGE
            && item.selectedAlternateItem.selectedZoneId > 0
            && item.selectedAlternateItem.cartItemId > 0));
}

export function isFullySelectedUnseatedFixedPackageItem(item: ISfoCartItem): boolean {
    return item.cartItemId > 0 && item.selectedZoneId > 0 && isFixedUnseatedAlternateItemSelected(item);
}
